export default __webpack_public_path__ + "static/jm-03c582a01c52e27dff28fee3e3c80dec.svg";